import type { SorterResult } from "antd/lib/table/interface";
import { type ExtendedColumnsType, GenericTable, type ResourceTableProps } from "components";
import { type FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import {
    displayDateTimeValue,
    displayStatusValue,
} from "../../../../components/Table/components/PropertyTable/transformations/cellTransformations";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../core/router/types/routerTypes";
import type { PaymentMethod } from "../../../types/entities/paymentMethod";

export const PaymentMethodsTable: FC<ResourceTableProps<PaymentMethod>> = ({ onStateChanged, onRowSelectionChange, datasource }) => {
    const { t } = useTranslation();
    const getColumnsConfig = useCallback(
        (sortInfo: SorterResult<PaymentMethod>): ExtendedColumnsType<PaymentMethod>[] => {
            return [
                {
                    title: t("mopList.id"),
                    key: "id",
                    dataIndex: "id",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "id" ? sortInfo.order : null,
                },
                {
                    title: t("mopList.name"),
                    key: "name",
                    dataIndex: "name",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "name" ? sortInfo.order : null,
                },
                {
                    title: t("mopList.type"),
                    key: "type",
                    dataIndex: "type",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "type" ? sortInfo.order : null,
                },
                {
                    title: t("mopList.mopType"),
                    key: "paymentType",
                    dataIndex: "paymentType",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "paymentType" ? sortInfo.order : null,
                },
                {
                    title: t("mopList.deductibility"),
                    key: "deductibility",
                    dataIndex: "deductibility",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "deductibility" ? sortInfo.order : null,
                },
                {
                    title: t("mopList.namosMopType"),
                    key: "posmoptype",
                    dataIndex: "posmoptype",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "posmoptype" ? sortInfo.order : null,
                },
                {
                    title: t("mopList.status"),
                    key: "status",
                    dataIndex: "status",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "status" ? sortInfo.order : null,
                    render: (value) => displayStatusValue(value),
                },
                {
                    title: t("mopList.changed"),
                    dataIndex: "changed",
                    key: "changed",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "changed" ? sortInfo.order : null,
                    render: (value) => displayDateTimeValue(value),
                },
            ];
        },
        [t],
    );

    const navigate = useNavigate();
    const onRowClick = (record: PaymentMethod) => navigate(`${BASE_PATH}/${ResourceName.PAYMENT_METHODS}/${FORM_ACTION.EDIT}/${record.id}`);

    return (
        (datasource && (
            <GenericTable<PaymentMethod>
                getColumnsConfig={getColumnsConfig}
                datasource={datasource}
                onSelectionCallback={onRowSelectionChange}
                onStateChanged={onStateChanged}
                onRow={(record: PaymentMethod) => {
                    return {
                        onClick: () => onRowClick(record),
                    };
                }}
            />
        )) ||
        null
    );
};
